<script setup lang="ts">
import { ref } from 'vue';
import Button from 'primevue/button';
import ConfirmPopup from 'primevue/confirmpopup';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'src/composables/useConfirm';

const { confirm } = useConfirm();
const toast = useToast();

const selectedOptions = ref<string[]>([]);
const options = [
  { label: 'scanblad', icon: 'pi pi-file' },
  { label: 'balie inname', icon: 'pi pi-desktop' },
  { label: 'pakbon', icon: 'pi pi-print' },
  { label: 'betaalbewijs', icon: 'pi pi-wallet' },
];

function onClickAction (e: Event) {
  const { onAccept, onReject } = confirm(e);

  onAccept(() => {
    toast.add({
      severity: 'success',
      summary: 'Printed',
      detail: 'The ticket has been printed',
      life: 3000,
    });

    selectedOptions.value = [];
  });

  onReject(() => {
    selectedOptions.value = [];
  });
}

</script>

<template>
  <div>
    <ConfirmPopup group="print-button">
      <template #message>
        <div class="p-3">
          <Listbox
            v-model="selectedOptions"
            :options="options"
            multiple
            class="w-full"
          >
            <template #option="slotProps">
              <div class="flex align-items-center">
                <span
                  :class="slotProps.option.icon"
                  class="mr-2"
                />
                <div>{{ slotProps.option.label }}</div>
              </div>
            </template>
          </Listbox>
        </div>
      </template>
    </ConfirmPopup>
    <Button
      label="Print"
      icon="pi pi-print"
      @click="onClickAction"
    />
  </div>
</template>
